/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { types } from '../../constants/search';

export interface IResult {
  id: string;
  title: string;
  slug: string;
  categorySlug: string;
  description: string;
  type: string;
  //unique fields for "community_forum_question" type
  uuid?: string;
  status?: number;
  views?: number;
  answersCount?: number;
  //unique fields for "ticket" type
  closedAt?: string;
  createdAt?: string;
}

interface IResultCount {
  total: number;
  type: string;
}

interface IPagination {
  currentPage: number;
  perPage: number;
}

interface ISearchState {
  value: string;
  resultCount: IResultCount[];
  resultList: IResult[];
  loading: boolean;
  selectedSearchScope: string;
  pagination: IPagination;
}

const initialState = {
  value: '',
  resultCount: [],
  resultList: [],
  loading: false,
  selectedSearchScope: types[0].slug,
  pagination: {
    currentPage: 1,
    perPage: 15,
  },
} as ISearchState;

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setValue(state, action: PayloadAction<string>) {
      state.value = action.payload;
    },
    setResultCount(state, action: PayloadAction<IResultCount[]>) {
      state.resultCount = action.payload;
    },
    setResultList(state, action: PayloadAction<IResult[]>) {
      state.resultList = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setSelectedSearchScope(state, action: PayloadAction<string>) {
      state.selectedSearchScope = action.payload;
      state.pagination = { ...state.pagination, currentPage: 1 };
    },
    setPagination(state, action: PayloadAction<Partial<IPagination>>) {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
});

export const {
  setValue,
  setResultCount,
  setResultList,
  setLoading,
  setSelectedSearchScope,
  setPagination,
} = searchSlice.actions;

export default searchSlice.reducer;
